import styled from "styled-components";
import Checkbox from "@mui/material/Checkbox";

export const CheckboxStyled = styled(Checkbox)`

`;
